import React, {useEffect} from 'react';
import {useRulesStore} from './rules.store';
import AgentLevelDescription from './components/agent-level-description';
import CommissionRateTable from './components/commission-rate-table';
import ClubExplanation from './components/club-explanation';
import StarRatingRequirements from './components/star-rating-requirements';
import FAQSection from './components/faq-section';
import {ProgressiveCircularLoading} from '@fe-progressive/package-progressive/progressive-loading';

const RulesContent: React.FC = () => {
  const {loading, loadData} = useRulesStore();

  useEffect(() => {
    loadData();
  }, [loadData]);

  if (loading) {
    return (
      <div className="flex-1 p-4 flex items-center justify-center">
        <ProgressiveCircularLoading />
      </div>
    );
  }

  return (
    <div className="flex-1 p-3 flex flex-col gap-3 overflow-y-auto">
      {/* 1. 代理等级说明 */}
      <AgentLevelDescription />

      {/* 2. 佣金率表格 */}
      <CommissionRateTable />

      {/* 3. 俱乐部说明 */}
      <ClubExplanation />

      {/* 4. 星级提升要求 */}
      <StarRatingRequirements />

      {/* 5. FAQ */}
      <FAQSection />
    </div>
  );
};

export default RulesContent;
